// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_spot_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { BiddingSpotService } from "./bidding_spot_service_pb";

/**
 * 対象日・市場の、 未登録コードの下限で取り込まなかった札の有無。明細は返さない。
 *
 * @generated from rpc bffuser.v1.BiddingSpotService.GetBidImportStatus
 */
export const getBidImportStatus = BiddingSpotService.method.getBidImportStatus;

/**
 * 一覧画面が必要とする spot / block 明細を 1 応答で返す。
 *
 * @generated from rpc bffuser.v1.BiddingSpotService.GetBiddingSpotScreen
 */
export const getBiddingSpotScreen = BiddingSpotService.method.getBiddingSpotScreen;

/**
 * 承認依頼の一覧。
 *
 * @generated from rpc bffuser.v1.BiddingSpotService.ListBiddingSpotApprovalRequests
 */
export const listBiddingSpotApprovalRequests = BiddingSpotService.method.listBiddingSpotApprovalRequests;

/**
 * 受渡日の操作履歴 (AC-BSP-038)。 オペレーション履歴タブの source。 通常入札とブロック入札の両方を返す。
 *
 * @generated from rpc bffuser.v1.BiddingSpotService.ListBiddingSpotOperationLogs
 */
export const listBiddingSpotOperationLogs = BiddingSpotService.method.listBiddingSpotOperationLogs;

/**
 * 承認依頼 1 件 + 全 SpotBid 明細を取得。
 *
 * @generated from rpc bffuser.v1.BiddingSpotService.GetBiddingSpotApprovalRequest
 */
export const getBiddingSpotApprovalRequest = BiddingSpotService.method.getBiddingSpotApprovalRequest;

/**
 * 承認依頼を新規作成。
 *
 * @generated from rpc bffuser.v1.BiddingSpotService.CreateBiddingSpotApprovalRequest
 */
export const createBiddingSpotApprovalRequest = BiddingSpotService.method.createBiddingSpotApprovalRequest;

/**
 * 下書きの更新。 楽観ロック使用。
 *
 * @generated from rpc bffuser.v1.BiddingSpotService.UpdateBiddingSpotApprovalRequest
 */
export const updateBiddingSpotApprovalRequest = BiddingSpotService.method.updateBiddingSpotApprovalRequest;

/**
 * 下書きの削除。 楽観ロック使用。
 *
 * @generated from rpc bffuser.v1.BiddingSpotService.DeleteBiddingSpotApprovalRequest
 */
export const deleteBiddingSpotApprovalRequest = BiddingSpotService.method.deleteBiddingSpotApprovalRequest;

/**
 * 承認ワークフローの状態遷移 (= 承認申請 / 承認 / 差戻し / 申請取消 / JEPX 提出 / 差戻し後再編集 を action で指定)。
 * 共通 BiddingLifecycleAction を使うが、 spot では WITHDRAW を渡すと InvalidArgument。
 * 楽観ロック使用。
 *
 * @generated from rpc bffuser.v1.BiddingSpotService.TransitionBiddingSpotApprovalState
 */
export const transitionBiddingSpotApprovalState = BiddingSpotService.method.transitionBiddingSpotApprovalState;

/**
 * 下書きの申請セットから、 指定した札だけを承認申請または提出する (AC-BSP-007 / #7758)。
 * 各 target の action は遷移させる申請セットの承認モードから導く (要承認 → 承認申請、 承認なし・自動 → 提出)。
 * 一部の札だけを指定した時は、 指定した札を元の申請セットに残して遷移し、 残りを新しい下書きへ移す。
 * 全 targets を 1 transaction で処理し、 どれか 1 つでも拒否されたら何も変えない。 楽観ロック使用 (target ごと)。
 *
 * @generated from rpc bffuser.v1.BiddingSpotService.TransitionBiddingSpotDrafts
 */
export const transitionBiddingSpotDrafts = BiddingSpotService.method.transitionBiddingSpotDrafts;

/**
 * 入札中 (JEPX 送信済) の札 1 枚の取下 (AC-BSP-057)。 対象は申請セットではなく
 * 子札 1 枚なので TransitionBiddingSpotApprovalState とは別 RPC。
 * JEPX への取消送信は非同期で、 成立まで札は「取下処理中」 に留まる (AC-BSP-057b)。
 * 楽観ロック使用 (基準値は札が属する申請セットの updated_at)。
 *
 * @generated from rpc bffuser.v1.BiddingSpotService.WithdrawBiddingSpotBid
 */
export const withdrawBiddingSpotBid = BiddingSpotService.method.withdrawBiddingSpotBid;

/**
 * 入札中の札の一括取下 (AC-BSP-116)。 件数の上限は無い。 1 トランザクションでまとめて取下処理中にし、
 * 取下できなかった札は理由を results に返す。 error 応答ならどの札も取り下げていない (通信の失敗では
 * 結果不明なので一覧を読み直す。 internalapi の同名 RPC 参照)。
 *
 * @generated from rpc bffuser.v1.BiddingSpotService.WithdrawBiddingSpotBids
 */
export const withdrawBiddingSpotBids = BiddingSpotService.method.withdrawBiddingSpotBids;

/**
 * 通常入札 CSV のチェック (= 構文 + 業務検証 + 差分プレビュー、 副作用なし)。
 *
 * @generated from rpc bffuser.v1.BiddingSpotService.CheckBiddingSpotNormalCsv
 */
export const checkBiddingSpotNormalCsv = BiddingSpotService.method.checkBiddingSpotNormalCsv;

/**
 * 通常入札 CSV の確定 (= check_token を引き換えて承認依頼を作成)。
 *
 * @generated from rpc bffuser.v1.BiddingSpotService.ApplyBiddingSpotNormalCsv
 */
export const applyBiddingSpotNormalCsv = BiddingSpotService.method.applyBiddingSpotNormalCsv;

/**
 * まとめて承認 (AC-BSP-118)。 件数の上限は無い。 1 トランザクションでまとめて承認し、 承認できなかった
 * 案件は理由を results に返す。 error 応答ならどの案件も承認していない (通信の失敗では結果不明なので
 * 一覧を読み直す。 internalapi の同名 RPC 参照)。
 *
 * @generated from rpc bffuser.v1.BiddingSpotService.ApproveBiddingSpotApprovalRequests
 */
export const approveBiddingSpotApprovalRequests = BiddingSpotService.method.approveBiddingSpotApprovalRequests;

/**
 * 手数料自動考慮 (スポット) の状態と、 希望価格から算出する入札価格 (AC-BSP-004b / AC-BSP-106)、
 * 保存済みの入札価格から逆算する希望価格を返す読み取り。 作成・下書きの更新
 * (BiddingSpotBidInput.fee_auto_consider) は同じ算出で入札価格を決める。
 *
 * @generated from rpc bffuser.v1.BiddingSpotService.PreviewBiddingSpotBidFeeAdjustedPrices
 */
export const previewBiddingSpotBidFeeAdjustedPrices = BiddingSpotService.method.previewBiddingSpotBidFeeAdjustedPrices;

/**
 * @generated from rpc bffuser.v1.BiddingSpotService.CheckBiddingSpotSubmissionDuplicates
 */
export const checkBiddingSpotSubmissionDuplicates = BiddingSpotService.method.checkBiddingSpotSubmissionDuplicates;
